import { motion } from "framer-motion";
import {
  MdOutlineAttachMoney,
  MdOutlineAccountBalance,
  MdOutlineWallet,
  MdOutlineCreditCard,
  MdOutlineSavings,
  MdOutlineShoppingBag,
  MdOutlineShoppingCart,
  MdOutlineAccountBalanceWallet,
  MdOutlineStorefront,
  MdOutlineShoppingBasket,
  MdOutlinePointOfSale,
  MdOutlineLocalMall,
} from "react-icons/md";
import { useMemo } from "react";
import clsx from "clsx";

const icons = [
  MdOutlineAttachMoney,
  MdOutlineAccountBalance,
  MdOutlineWallet,
  MdOutlineCreditCard,
  MdOutlineSavings,
  MdOutlineShoppingBag,
  MdOutlineShoppingCart,
  MdOutlineAccountBalanceWallet,
  MdOutlineStorefront,
  MdOutlineShoppingBasket,
  MdOutlinePointOfSale,
  MdOutlineLocalMall,
];

const pastelColors = [
  "text-black/10 dark:text-white/10",
  "text-black/10 dark:text-white/10",
  "text-black/10 dark:text-white/10",
  "text-black/10 dark:text-white/10",
  "text-black/10 dark:text-white/10",

  // "text-black/10 dark:text-white/10",
  // "text-blue-200/40 dark:text-blue-400/10",
  // "text-green-200/40 dark:text-green-400/10",
  // "text-yellow-200/40 dark:text-yellow-400/10",
  // "text-pink-200/40 dark:text-pink-400/10",
];

const generateFloatingItems = (count: number) =>
  Array.from({ length: count }, (_, i) => {
    const Icon = icons[i % icons.length];
    const size = Math.floor(Math.random() * 32) + 8;
    const left = Math.random() * 100;
    const delay = Math.random() * 2;
    const duration = 20 + Math.random() * 8; // más lento: 16-24s
    const colorClass =
      pastelColors[Math.floor(Math.random() * pastelColors.length)];
    const rotateDuration = 20 + Math.random() * 10; // más lento: 30-40s
    const scale = 0.9 + Math.random() * 0.2;
    const zIndex = Math.random() > 0.5 ? "z-0" : "z-[-1]";
    const topStart = 40 + Math.random() * 60; // 40vh - 100vh

    return (
      <motion.div
        key={i}
        className={clsx("absolute", colorClass, zIndex)}
        style={{ left: `${left}%`, fontSize: size }}
        initial={{
          y: `${60 + Math.random() * 40}vh`,
          x: 0,
          opacity: 0.2,
          rotate: 0,
          scale,
        }}
        animate={{
          y: "-20vh",
          x: [0, -10, 10, 0], // deriva horizontal en S
          opacity: 1,
          rotate: 360,
          scale: [scale, scale * 1.05, scale],
        }}
        transition={{
          y: { duration, repeat: Infinity, delay, ease: "easeInOut" },
          x: { duration: duration * 1.2, repeat: Infinity, ease: "easeInOut" },
          rotate: {
            duration: rotateDuration,
            repeat: Infinity,
            ease: "linear",
          },
          scale: {
            duration: 10,
            repeat: Infinity,
            repeatType: "mirror",
            ease: "easeInOut",
          },
        }}
      >
        <Icon />
      </motion.div>
    );
  });

const LayoutBackgroundFloatingIcons: React.FC = () => {
  const floatingItems = useMemo(() => generateFloatingItems(20), []);

  return (
    <div
      className={clsx(
        "fixed",
        "inset-0",
        "z-0",
        "pointer-events-none",
        "overflow-hidden"
      )}
    >
      {floatingItems}
    </div>
  );
};

export default LayoutBackgroundFloatingIcons;
